import List from '@mui/material/List';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import NavigationItem from './components/navigation-item';
import { appRoutesLazy } from './route-config-lazy';

const NavigationList = () => {
  const [selected, setSelected] = useState(-1);
  const { pathname = '' } = useLocation();

  useEffect(() => {
    let found = false;
    appRoutesLazy.forEach((element, id) => {
      if (pathname.includes(`/${element.path}`)) {
        setSelected(id);
        found = true;
      }
    });

    if (!found) {
      setSelected(-1);
    }
  }, [pathname]);

  return (
    <List component="nav">
      {appRoutesLazy.map((item, id) => (
        <NavigationItem
          elements={item.elements}
          Icon={item.Icon}
          title={item.title}
          key={id}
          component={item.component}
          path={item.path}
          isSelected={selected === id}
          onClick={() => setSelected(id)}
          getProtection={item.getProtection}
        />
      ))}
    </List>
  );
};

export default NavigationList;
